import type { CSSObject } from '@emotion/react'

export const container: CSSObject = {
  border: 'none',
  display: 'flex',
}
